import * as React from 'react';
import withStyles from 'react-jss';
import { Button } from 'src/design-system/components/atoms';
import { StylesProps } from 'src/types/common.types';
import styles from './CliResult.styles';

type ResultStatus = 'success' | 'denied' | 'error';

interface CardContent {
  title: string;
  message: string;
}

const CONTENT_BY_STATUS: Record<ResultStatus, CardContent> = {
  success: {
    title: 'CLI authorized',
    message: 'You can close this tab and return to your terminal.',
  },
  denied: {
    title: 'CLI access denied',
    message: 'You can close this tab and return to your terminal.',
  },
  error: {
    title: 'Something went wrong',
    message:
      'The CLI could not complete sign-in. You can close this tab and re-run the login command from your terminal.',
  },
};

const FALLBACK_CONTENT: CardContent = {
  title: 'No CLI login in progress',
  message: 'There is no CLI login result to display.',
};

const parseStatus = (search: string): ResultStatus | null => {
  const value = new URLSearchParams(search).get('status');
  if (value === 'success' || value === 'denied' || value === 'error') return value;
  return null;
};

interface IProps extends StylesProps<ReturnType<typeof styles>> {}

const CliResult = (props: IProps) => {
  const { classes } = props;
  const status = parseStatus(window.location.search);
  const content = status ? CONTENT_BY_STATUS[status] : FALLBACK_CONTENT;

  const goToDashboard = () => {
    window.location.href = '/';
  };

  return (
    <div className={classes.pageContainer}>
      <div className={classes.card}>
        <h2 className={classes.title}>{content.title}</h2>
        <p className={classes.message}>{content.message}</p>
        <div className={classes.actions}>
          <Button type="primary" onClick={goToDashboard}>Go to dashboard</Button>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles, { injectTheme: true })(CliResult);
